'use client'

import { useState } from 'react'

export type UseCopyToClipboardOptions = {
  copiedDuration?: number
}

export const useCopyToClipboard = ({ copiedDuration = 3000 }: UseCopyToClipboardOptions = {}) => {
  const [isCopied, setIsCopied] = useState<boolean>(false)

  const copyToClipboard = (value: string) => {
    if (!value || typeof navigator === 'undefined' || !navigator.clipboard) {
      return
    }

    navigator.clipboard.writeText(value).then(
      () => {
        setIsCopied(true)
        setTimeout(() => setIsCopied(false), copiedDuration)
      },
      () => {}
    )
  }

  return { isCopied, copyToClipboard }
}
